import Image from 'components/Basic/Image/Image';
import Link from 'components/Basic/Link/Link';
import { LoginForm } from 'components/Blocks/LoginForm/LoginForm';
import {
    ClubBenefitsItemStyled,
    ClubBenefitsListStyled,
    ClubIconStyled,
    ClubStyled,
    LoginColumnStyled,
    LoginContentStyled,
    MembershipBenefitsLink,
} from 'components/Blocks/Popup/Login/Login.style';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { getTescomaClubCardImage } from 'helpers/getTescomaClubImage';
import useTranslation from 'next-translate/useTranslation';
import { SimpleCheckmarkIcon } from 'public/svg/IconsSvg';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

export type LoginPopupContentProps = {
    isMobileView: boolean | undefined;
};

export const LoginContent: FC<LoginPopupContentProps> = ({ isMobileView }) => {
    const { t } = useTranslation();
    const { url, defaultLocale } = useDomainConfig();
    const [registrationUrl, tescomaClubUrl] = getInternationalizedStaticUrls(['/registration', '/tescoma-club'], url);

    const clubBenefitsListItems = t('Login popup benefits list').split('||');

    return (
        <LoginContentStyled>
            <LoginColumnStyled>
                <ClubStyled>
                    <ClubIconStyled>
                        <Image
                            alt={t('Tescoma club')}
                            className="max-h-[63px] max-w-[100px]"
                            height={63}
                            src={getTescomaClubCardImage(defaultLocale)}
                            width={100}
                        />
                    </ClubIconStyled>
                    {isMobileView === undefined || !isMobileView ? (
                        <h3 className="mb-2 inline-block break-keep text-h3 leading-6 vl:mb-[22px] vl:text-h2 vl:leading-8">
                            {t('Tescom Club Member Benefits')}
                        </h3>
                    ) : (
                        <h3 className="font-weight-400 mb-2 inline-block break-keep text-h3 leading-6 vl:mb-[22px] vl:text-h2 vl:leading-8">
                            {t('Tescom Club Member Benefits')}
                        </h3>
                    )}
                    {clubBenefitsListItems.length > 0 && (
                        <ClubBenefitsListStyled>
                            {clubBenefitsListItems.map((benefit, index) => (
                                <ClubBenefitsItemStyled key={index}>
                                    <SimpleCheckmarkIcon />
                                    <span dangerouslySetInnerHTML={{ __html: benefit }} />
                                </ClubBenefitsItemStyled>
                            ))}
                        </ClubBenefitsListStyled>
                    )}
                    {isMobileView !== undefined && (
                        <MembershipBenefitsLink href={tescomaClubUrl}>
                            {t('What are the benefits of membership')}
                        </MembershipBenefitsLink>
                    )}
                    <Link isButton href={registrationUrl} size="small" type="registration">
                        {t('Create account')}
                    </Link>
                </ClubStyled>
            </LoginColumnStyled>
            <LoginColumnStyled>
                <LoginForm />
            </LoginColumnStyled>
        </LoginContentStyled>
    );
};
